import { UliActivityType } from '../../../../../common/constants/uli';
import { AllocationViewActionIdentifierTypeEnum } from '../constants/allocation-view-action-request.constant';

export class AllocationViewSelectedEntityModel {
  identifier: AllocationViewActionIdentifierModel;
  type: AllocationViewActionIdentifierTypeEnum;
}

export class AllocationViewActionIdentifierModel {
  hubId: number;
  truckId?: number;
  slot: AllocationViewActionRequestSlotModel;
  ulis: AllocationViewActionRequestUliModel[];
}

export class AllocationViewActionRequestUliModel {
  compartmentId: number;
  type: UliActivityType;
  uli: string;
  truckId?: number;
}

export class AllocationViewActionRequestSlotModel {
  compartmentId: number;
  slotId: number;
}
